import React from 'react';

type TextProps = React.CSSProperties;

const Text: React.FC<TextProps> = ({ children, ...rest }) => {
  return <p style={{ ...rest }}>{children}</p>;
};

export default Text;
